import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler } from '@angular/common/http';
import { KeycloakSupportService } from './keycloak-support.service';

@Injectable()
export class KeycloakHttpService extends HttpClient {

  constructor (httpHandler: HttpHandler) {

    super(httpHandler);
    KeycloakSupportService.http = new HttpClient(httpHandler);
  }

}
